import { EventTrackingProps, ToastType } from "@/types/common";
import { createContext, useContext } from "react";

import { LoginData } from "@/components/login/loginForms/type";

const defaultTranslation: any = {};
export const LoginContext = createContext({
  page: "login" as "login" | "sign-out",
  translation: defaultTranslation,
  isMobile: false,
  loginStep: "LOGIN",
  loginData: {} as LoginData,
  setLoginData: (data: any) => {},
  setLoginStep: (step: string) => {},
  showToast: (val: ToastType) => {},
  handleEventTracking: (event: EventTrackingProps) => {},
  hostname: "",
});

export function useLogin() {
  return useContext(LoginContext);
}
